export default "__VITE_ASSET__CbV5SZhJ__"